import { useState } from 'react';
import { SimBanner } from '../components/SimBanner';
import styles from './LoginPage.module.css';

interface Props {
  onLogin:    (username: string, password: string) => Promise<boolean>;
  onRegister: (payload: { name: string; email: string; username: string; password: string }) => Promise<boolean>;
  loading:    boolean;
  error:      string;
}

export function LoginPage({ onLogin, onRegister, loading, error }: Props) {
  const [tab,      setTab]      = useState<'login' | 'signup'>('login');
  const [success,  setSuccess]  = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [name,     setName]     = useState('');
  const [email,    setEmail]    = useState('');
  const [regUser,  setRegUser]  = useState('');
  const [regPass,  setRegPass]  = useState('');
  const [regErr,   setRegErr]   = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    await onLogin(username, password);
  };

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setRegErr('');
    if (regPass.length < 8) { setRegErr('Password must be at least 8 characters.'); return; }
    const ok = await onRegister({ name, email, username: regUser, password: regPass });
    if (ok) {
      setSuccess('Account created! Switch to Login to sign in.');
      setName(''); setEmail(''); setRegUser(''); setRegPass('');
    } else {
      setRegErr('Registration failed.');
    }
  };

  return (
    <div className={styles.screen}>
      <SimBanner />
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.title}>// AI Persona System</div>
          <div className={styles.sub}>Research interface — authenticate to continue</div>
        </div>
        <div className={styles.tabs}>
          <button className={`${styles.tab} ${tab === 'login' ? styles.activeTab : ''}`}
            onClick={() => { setTab('login'); setSuccess(''); }}>login</button>
          <button className={`${styles.tab} ${tab === 'signup' ? styles.activeTab : ''}`}
            onClick={() => { setTab('signup'); setSuccess(''); }}>register</button>
        </div>
        <div className={styles.body}>
          {tab === 'login' ? (
            <form onSubmit={handleLogin}>
              <div className={styles.field}>
                <label className={styles.label}>username</label>
                <input className={styles.input} type="text" value={username}
                  onChange={e => setUsername(e.target.value)} placeholder="your_username"
                  autoComplete="username" required />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>password</label>
                <input className={styles.input} type="password" value={password}
                  onChange={e => setPassword(e.target.value)} placeholder="••••••••"
                  autoComplete="current-password" required />
              </div>
              {error && <div className={styles.error}>{error}</div>}
              <button className={styles.submit} type="submit" disabled={loading}>
                {loading ? 'authenticating...' : 'login →'}
              </button>
            </form>
          ) : (
            <form onSubmit={handleRegister}>
              <div className={styles.field}>
                <label className={styles.label}>display name</label>
                <input className={styles.input} type="text" value={name}
                  onChange={e => setName(e.target.value)} placeholder="Your Name" required />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>email</label>
                <input className={styles.input} type="email" value={email}
                  onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>username</label>
                <input className={styles.input} type="text" value={regUser}
                  onChange={e => setRegUser(e.target.value)} placeholder="no_spaces" required />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>password (min 8)</label>
                <input className={styles.input} type="password" value={regPass}
                  onChange={e => setRegPass(e.target.value)} placeholder="••••••••" required />
              </div>
              {(regErr || error) && <div className={styles.error}>{regErr || error}</div>}
              {success && <div className={styles.successMsg}>{success}</div>}
              <button className={styles.submit} type="submit" disabled={loading}>
                {loading ? 'creating...' : 'create account →'}
              </button>
              <div className={styles.note}>New accounts start with user role.</div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
